export default __webpack_public_path__ + "static/media/Relic of the Hell Walker.000bfd4b.jpg";